import axios from 'axios'
import styles from './GrafanaPage.module.scss'
import './GrafanaGeneralStyle.scss'
import { useState } from 'react'
import { GRAFANA_URL } from '../../config/config'
export default function GrafanaPage() {

  const [token, setToken] = useState("")
  const [userId, setUserId] = useState("A416782")
  const [message, setMessage] = useState("")
  const handleGetlogin = () => {
    axios.post(GRAFANA_URL+'/loginproxy', {
      userId: userId
    }).then(
      (response) => {


        setToken(response.data.token)
        setMessage("")
      }
    ).catch(
      (error) => {

        setMessage("User not found")
    }

    )
  }

  return (
    <div className={styles['page']}>
        <h1>GrafanaPage</h1>
        {token !=="" &&
        <div className={styles['iframe-container']}>
          <iframe className={styles['iframe']} title="Grafana Dashboard" src={GRAFANA_URL+"?tokenproxy="+token} width="100%" height="100%"></iframe>
        </div>
}
        <p>{message}</p>
        <input type="text" value={userId} onChange={(e) => setUserId(e.target.value)} />
        <button className={styles['button']} onClick={handleGetlogin}>Get Login Grafan</button>
    </div>
  
  )
}
